import React, { useContext, useEffect, useState } from "react";
import { store } from "../../App";
import {
  NetActivity,
  DualAxesChart,
  LineChart,
  BarChart,
  HoldingsPercentageTable
} from "../../components";
import { SectorActivity } from './SectorActivity'
import { SectorAllocation } from './SectorAllocation'
import { AssetAllocationChart } from "../../components/AssetAllocationChart";

export const Default = () => {
  const [token, setToken, userId, setUserId] = useContext(store);

  return (
    <div>
      <div className="header">
        <h1 className="header-title">
          Welcome back, {userId && userId.firstName}!
        </h1>
      </div>
      <div className="row">
        <div className="col-12 col-md-12 col-xxl-2 d-flex">
          <NetActivity />
        </div>
        <div className="col-12 col-md-12 col-xxl-10 d-flex ">
          <DualAxesChart />
        </div>

        <div className="col-xl-7 col-xxl-8 d-flex">
          <LineChart
            chartTitle="Balance History"
            chartLabel="date"
            dataValue="marketValue"
          />
        </div>
        <div className="col-12 col-md-12 col-xxl-4 d-flex">
          <BarChart />
        </div>
        <div className="col-12 col-md-12 col-xxl-4 d-flex">
          <SectorAllocation title="Sector Allocation" />
        </div>
        <div className="col-12 col-md-12 col-xxl-4 d-flex">
          <HoldingsPercentageTable />
        </div>
        <div className="col-12 col-md-12 col-xxl-4 d-flex">
          <AssetAllocationChart title="Asset Allocation" />
        </div>
        <div className="col-12 col-md-12 col-xxl-12 d-flex">
          <SectorActivity chartTitle="Sector Activity" />
        </div>
      </div>
    </div>
  );
};
